/**
 * Based on code from:
 * https://github.com/Kitware/VolView/blob/main/src/vtk/CrosshairsWidget/index.js
 */

import macro from "vtk.js/Sources/macros";
import vtkAbstractWidgetFactory from "vtk.js/Sources/Widgets/Core/AbstractWidgetFactory";
import vtkPlanePointManipulator from "vtk.js/Sources/Widgets/Manipulators/PlaneManipulator";

import { ViewTypes } from "vtk.js/Sources/Widgets/Core/WidgetManager/Constants";

import stateGenerator from "./state";
import widgetBehavior from "./behavior";

// ----------------------------------------------------------------------------
// Factory
// ----------------------------------------------------------------------------

function vtkCrosshairsWidget(publicAPI, model) {
    model.classHierarchy.push("vtkCrosshairsWidget");

    // --- Widget Requirement ---------------------------------------------------

    model.behavior = widgetBehavior;
    model.widgetState = stateGenerator();

    publicAPI.getRepresentationsForViewType = (viewType) => {
        switch (viewType) {
            case ViewTypes.DEFAULT:
            case ViewTypes.GEOMETRY:
            case ViewTypes.SLICE:
            case ViewTypes.VOLUME:
            default:
                return [];
        }
    };

    // --------------------------------------------------------------------------
    // initialization
    // --------------------------------------------------------------------------

    model.widgetState.onBoundsChange((bounds) => {
        const center = [
            (bounds[0] + bounds[1]) * 0.5,
            (bounds[2] + bounds[3]) * 0.5,
            (bounds[4] + bounds[5]) * 0.5,
        ];
        model.widgetState.getHandle().setOrigin(center);
    });

    // Default manipulator
    model.manipulator = vtkPlanePointManipulator.newInstance();
}

// ----------------------------------------------------------------------------

const DEFAULT_VALUES = {
    // manipulator: null,
};

// ----------------------------------------------------------------------------

export function extend(publicAPI, model, initialValues = {}) {
    Object.assign(model, DEFAULT_VALUES, initialValues);

    vtkAbstractWidgetFactory.extend(publicAPI, model, initialValues);
    macro.setGet(publicAPI, model, ["manipulator"]);

    vtkCrosshairsWidget(publicAPI, model);
}

// ----------------------------------------------------------------------------

export const newInstance = macro.newInstance(extend, "vtkCrosshairsWidget");

// ----------------------------------------------------------------------------

export default { newInstance, extend };
